<script setup>

</script>

<template>
    <template v-if="$page.props.customer?.email && $page.props.customer?.is_dealer">
        <slot name="without_vat" :active="true"></slot>
        <slot name="with_vat" :active="false"></slot>
    </template>

    <template v-else>
        <slot name="with_vat" :active="true"></slot>
        <slot name="without_vat" :active="false"></slot>
    </template>
</template>

<style scoped lang="scss">

</style>
